import HowToArticle from 'components/articles/HowToArticle';
import { Link as MuiLink } from '@material-ui/core';
import { Link } from 'react-router-dom';
import rotateImage from 'components/articles/how-to-rotate-an-image.png';

const image = {
  src: rotateImage,
  width: 1100,
  height: 760,
  alt: 'PhotoUtils screenshot: how to rotate a photo online',
  title: 'How to flip an image horizontally or vertically',
  type: 'image/png',
};

function HowToRotate() {
  return (
    <HowToArticle
      action="rotate"
      description="How to convert horizontal picture to vertical, vertical to horizontal or turn an image upside down. You can easily convert landscape photo to portrait and vice versa without downloading any software, your browser is enough."
      image={image}
      publishedTime={'2020-11-27T10:27:38'}
      modifiedTime={'2020-11-27T10:27:38'}
    >
      Convert horizontal picture to vertical, vertical to horizontal, or turn an image upside down. Happens that
      pictures taken on iPhone or other phones are not displayed correctly on some devices or websites. Or you have a
      landscape photo you want to make a portrait and vice versa. There are many apps available in the store which can
      rotate such pictures and resolve the issue. But you don't want to install yet another app, don't you? No need to,
      your browser is enough! Just do these 3 steps to rotate an image online:
      <ol>
        <li>
          Open{' '}
          <MuiLink to="/" component={Link}>
            PhotoUtils
          </MuiLink>
          {', '}
          upload a picture and choose the <strong>Rotate</strong> tool
        </li>
        <li>Pick the rotation direction: right, left or 180&deg;</li>
        <li>
          Click <strong>Rotate</strong> to download adjusted image
        </li>
      </ol>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img {...image} />
    </HowToArticle>
  );
}

export default HowToRotate;
